'use client';

import { useEffect } from 'react';

const YANDEX_API_KEY = process.env.NEXT_PUBLIC_YANDEX_MAPS_API_KEY || '';
const SCRIPT_SRC = `https://api-maps.yandex.ru/2.1/?apikey=${YANDEX_API_KEY}&lang=ru_RU`;

/**
 * Preloads the Yandex Maps API script during browser idle time
 * so the map is ready instantly when the address modal opens.
 */
export function YandexMapPreloader() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Already loaded or loading
    if (window.ymaps || document.querySelector('script[src*="api-maps.yandex.ru"]')) return;

    const load = () => {
      // Another map can start loading while this idle callback is queued.
      if (window.ymaps || document.querySelector('script[src*="api-maps.yandex.ru"]')) return;
      const script = document.createElement('script');
      script.src = SCRIPT_SRC;
      script.async = true;
      // A failed idle preload must not block an explicit retry in the map.
      script.addEventListener('error', () => script.remove(), { once: true });
      document.head.appendChild(script);
    };

    // Use requestIdleCallback to avoid blocking initial render
    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(load, { timeout: 3000 });
      return () => cancelIdleCallback(id);
    } else {
      const timer = setTimeout(load, 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  return null;
}
